import React from "react";

const MenuItem = ({
  name,
  iconPath,
  isDropdown = false,
  isOpen = false,
  onClick,
  title,
  ariaLabel,
  className = "",
  children,
  badge,
  badgePosition = "bottom-right",
  isSuperscript = false,
  compactMode = false,
}) => {
  const getBadgePosition = () => {
    switch (badgePosition) {
      case "top-right":
        return "absolute right-0 top-0";
      case "top-left":
        return "absolute left-0 top-0";
      case "bottom-left":
        return "absolute left-0 bottom-0";
      case "bottom-right":
      default:
        return "absolute right-0 bottom-0";
    }
  };

  return (
    <div className={`relative mx-0.5 lg:mx-1`}>
      <button
        onClick={onClick}
        className={`select-none px-0.5 sm:px-1 md:px-2 lg:px-3 py-1 sm:py-2 text-slate-300 h-12 sm:h-14 md:h-16 lg:h-18 xl:h-20 hover:text-white flex items-center justify-center transition-all duration-200 ${
          name === "Profile" ? "hover:scale-105" : ""
        } ${className}`}
        title={title}
        aria-label={ariaLabel || title}
      >
        <div
o           className={`flex flex-col items-center justify-center transition-all duration-300 ease-in-out w-4 sm:w-5 md:w-6 ${
            compactMode ? "h-6 sm:h-8" : "h-10 sm:h-12"
          } ${compactMode ? "" : "gap-1 sm:gap-2"}`}
        >
          <div
            className={`flex items-center justify-center ${
              name === "Profile"
                ? "w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 lg:w-7 lg:h-7 xl:w-8 xl:h-8"
                : "w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 lg:w-6 lg:h-6"
            }`}
          >
            {iconPath ? (
              <img
                src={iconPath}
                alt={name}
                draggable={false}
                className={`${
                  title == "Profile"
                    ? "w-4 h-4 md:w-7 md:h-7 rounded-full"
                    : "h-3 sm:h-4 md:h-5 object-cover  hover:border-gray-400 transition-all duration-200"
                }`}
              />
            ) : (
              children
            )}
          </div>

          {title && (
            <div
              className={`flex flex-col items-center justify-center ${
                compactMode
                  ? "h-0 opacity-0 overflow-hidden"
                  : "h-6 opacity-100"
              } transition-all duration-300 ease-in-out`}
            >
              <span className="select-none text-[10px] sm:text-[12px] text-[#7F7F7F] whitespace-nowrap">
                {title}
              </span>
            </div>
          )}

          {isDropdown && (
            <div
              className={`flex items-center justify-center transition-all duration-300 ease-in-out ${
                compactMode
                  ? "h-0 opacity-0 overflow-hidden"
                  : "h-4 opacity-100"
              }`}
            >
              <img
                src="/icons/chevronDown.png"
                alt="dropdown"
                className={`w-4 transition-transform duration-200 ${
                  isOpen ? "rotate-180" : ""
                }`}
              />
            </div>
          )}
        </div>

        {badge && (
          <span
            className={`pointer-events-none ${
              isSuperscript
                ? `absolute ${
                    compactMode ? "top-5 right-1" : "-top-0 right-1"
                  } text-blue-500 text-xs font-semibold  flex items-center justify-center shadow-sm`
                : `${getBadgePosition()} text-[#7F7F7F] text-sm`
            }`}
          >
            {badge}
          </span>
        )}
      </button>
    </div>
  );
};

export default MenuItem;
